import "./App.css";

import Temp from "./components/weather/temp";

const App = () => {
  return (
    <>
      <Temp />
    </>
  );
};

export default App;
